import { thinkTag, contentType } from './constant';
import { personalized_recommend_content_type_list } from '../contants/personalRecommend';
import { Allow, parse } from 'partial-json';

// 标签配置
// const START_TAG_REGEX = /<citation(?:\s+[a-zA-Z_][a-zA-Z0-9_-]*(?:=(?:"[^"]*"|'[^']*'|[^'"\s]+))?)*\s*>/;
// const END_TAG = '</citation>';
export const isCompleteTag = (content, startTag, endTag) => {
    const startIndex = content.indexOf(startTag);
    // 查找结束标签
    const endIndex = content.indexOf(endTag);
    if (startIndex !== -1 && endIndex !== -1) {
        return true;
    }
    return false;
};
export const isTextType = (content_type) => {
    if (
        content_type === contentType.annotation ||
        content_type === contentType.sensitive ||
        content_type === contentType.exception ||
        content_type === contentType.text ||
        content_type === contentType.retrieval
    ) {
        return true;
    }
    return false;
};
// todo--将所有智能体的回答都放到一个数组中，显示的时候直接根据类型循环即可
//当前是直接根据类型显示的，如果出现多个同类型的但是在不同model里的会导致合并
const default_recommend_course_result = {
    loading: false,
    data: [],
    count: 0,
    description: ''
};

export class FlowMsg {
    constructor() {
        this.hasContent = false;
        this.processing = false;
        this.answerOpened = false;
        this.messageResult = '';
        this.eventMsg = '';
        this.isThinking = false;
        this.web_result = {};
        this.retrieval_result = {};
        this.answerContent = '';
        this.thinkContent = '';
        this.inTagProcessing = false; // 是否处于引用块中
        this.buffer = ''; //不完整标签的缓存区
        this.recommend_course_result = null; //课程推荐
        this.isDone = false; // 添加完成标记
        this.hasOptions = false; // 标记是否有按钮选项
        this.options = []; // 存储按钮选项
        this.lastPlannerContent = '';
        this.recommendBuffer = ''; //课程推荐缓存区
        this.multimodalBuffer = ''; // 多模态结果缓存区
        this.multimodal_learning_result = null; // 多模态学习结果
        // this.ai_evaluation_result = { title: '', criteria: '', style: { custom: true, text: '' }, requirements: '', status: 0 };
        this.ai_evaluation = null;
        this.card_result = null;
        this.intelligent_qa_result = null;
        this.personal_recommend_result = null;
    }

    // 处理标签逻辑，支持多标签
    processCompleteTags(content, tagNames = ['citation']) {
        const tags = Array.isArray(tagNames) ? tagNames : [tagNames];
        this.buffer += content;
        let processed;

        do {
            processed = false;
            let earliest = null;

            for (const tagName of tags) {
                // 匹配开始标签
                const START_TAG_REGEX = new RegExp(`<${tagName}(?:\\s+[a-zA-Z_][a-zA-Z0-9_-]*(?:=(?:"[^"]*"|'[^']*'|[^'"\\s]+))?)*\\s*>`, 'g');
                let match;
                START_TAG_REGEX.lastIndex = 0;
                while ((match = START_TAG_REGEX.exec(this.buffer)) !== null) {
                    const startIndex = match.index;
                    const startTagLen = match[0].length;
                    const endTagStr = `</${tagName}>`;
                    // 从开始标签后面去找对应的结束标签，不是全局indexOf
                    const endIndex = this.buffer.indexOf(endTagStr, startIndex + startTagLen);

                    if (endIndex !== -1) {
                        // 找到一对完整标签
                        if (!earliest || startIndex < earliest.index) {
                            earliest = {
                                index: startIndex,
                                tagName,
                                endIndex: endIndex,
                                endTagLen: endTagStr.length
                            };
                        }
                    }
                    // 只取最早的一个开始标签，break循环
                    break;
                }
            }

            if (!earliest) {
                // 没有完整标签对，全部推入结果，清空buffer
                this.messageResult += this.buffer;
                this.buffer = '';
                break;
            }

            // 输出最早标签之前普通文本
            if (earliest.index > 0) {
                this.messageResult += this.buffer.substring(0, earliest.index);
                this.buffer = this.buffer.substring(earliest.index);
            }

            // 消费完整标签对
            const consumeUntil = earliest.endIndex + earliest.endTagLen;
            this.messageResult += this.buffer.substring(0, consumeUntil);
            this.buffer = this.buffer.substring(consumeUntil);
            processed = true;
        } while (processed);
    }

    //处理标注---匹配到标注内容
    handleAnnotation = (content) => {
        this.reset();
        this.messageResult = content;
        this.answerContent = content;
        this.hasContent = true;
    };

    //处理错误
    handleError = (content) => {
        this.reset();
        this.messageResult = content;
        this.isDone = true; // 错误时标记为完成
        this.answerContent = content;
        this.hasContent = true;
    };

    //处理联网搜索
    handleWebSearch = (content) => {
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }

        this.web_result = jsonContent;
        this.hasContent = true;
    };

    //处理知识库检索
    handleRetrieval = (content) => {
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }
        this.retrieval_result = jsonContent;
        this.hasContent = true;
    };
    //课程推荐
    handleCourseRecommend = (content) => {
        this.recommendBuffer += content;
        try {
            const json = parse(this.recommendBuffer, Allow.ALL);
            this.recommend_course_result = json;
            this.hasContent = true;
        } catch (e) {
            this.recommend_course_result = {};
            return false;
        }
    };
    //ai评阅-项目
    handleAiEvaluationItem = (content) => {
        if (!this.ai_evaluation) {
            this.ai_evaluation = {};
        }
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }
        this.ai_evaluation.ai_evaluation_item = jsonContent;
        this.hasContent = true;
    };
    //ai评阅-结果
    handleAiEvaluationResult = (content) => {
        if (!this.ai_evaluation) {
            this.ai_evaluation = {};
        }
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }
        this.ai_evaluation.ai_evaluation_result = jsonContent;
        this.hasContent = true;
    };
    //处理卡片--案例仿真使用
    handleCard = (content) => {
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }
        this.card_result = jsonContent;
        this.hasContent = true;
    };
    //智能问答
    handleIntelligentQaStatus = (content, content_type) => {
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }
        if (content_type === contentType.intelligent_qa_status) {
            this.intelligent_qa_result.intelligent_qa_status = jsonContent;
        }
        if (content_type === contentType.intelligent_qa_clarification) {
            this.intelligent_qa_result.intelligent_qa_clarification = jsonContent;
        }

        this.hasContent = true;
    };
    //个性化推荐
    handlePersonalizedRecommend = (content, content_type) => {
        let jsonContent = {};
        try {
            jsonContent = JSON.parse(content);
        } catch (error) {
            jsonContent = {};
        }
        if (
            content_type === contentType.personalized_recommend_intent_reasoning ||
            content_type === contentType.personalized_recommend_re_intent_reasoning ||
            content_type === contentType.personalized_recommend_reasoning ||
            content_type === contentType.personalized_recommend_ask_reason
        ) {
            if (!this.personal_recommend_result[content_type]) {
                this.personal_recommend_result[content_type] = '';
            }
            this.personal_recommend_result[content_type] += content;
        } else {
            this.personal_recommend_result[content_type] = jsonContent;
        }

        this.hasContent = true;
    };
    //链路开始
    handleChainStart = (content, content_type) => {
        if (content_type === contentType.workflow) {
            this.processing = true;
        }
        //课程推荐
        if (content_type === contentType.recommend_course) {
            if (!this.recommend_course_result) {
                this.recommend_course_result = {};
            }
            this.recommend_course_result.loading = true;
        }
        //智能问答
        if (content_type === contentType.intelligent_qa_status) {
            if (!this.intelligent_qa_result) {
                this.intelligent_qa_result = {};
            }
            this.intelligent_qa_result.loading = true;
        }
        //个性化推荐
        if (personalized_recommend_content_type_list.includes(content_type)) {
            if (!this.personal_recommend_result) {
                this.personal_recommend_result = {};
            }
            if (content_type === contentType.personalized_recommend_intent) {
                this.personal_recommend_result.personalized_recommend_intent_reasoning = thinkTag[0];
            }
            if (content_type === contentType.personalized_recommend_re_intent) {
                this.personal_recommend_result.personalized_recommend_re_intent_reasoning = thinkTag[0];
            }

            if (content_type === contentType.personalized_recommend_result) {
                this.handlePersonalizedRecommend(content, content_type);
            }

            this.personal_recommend_result.loading = true;
        }
    };
    //链路流
    handleChainStream = (content, content_type, message_type) => {
        if ((content_type === 'text' && (message_type === 'answer' || !message_type)) || content_type === contentType.markdown) {
            this.answerContent += content;
            //如果答案标签未拼接，先拼接答案开始标签
            if (!this.answerOpened) {
                this.answerOpened = true;
            }
            if (content) {
               return this.processCompleteTags(content, ['citation', 'glink']);
            }
        }
        if (personalized_recommend_content_type_list.includes(content_type)) {
            this.handlePersonalizedRecommend(content, content_type);
        }
        //智能问答
        if (content_type === contentType.intelligent_qa_status || content_type === contentType.intelligent_qa_clarification) {
            this.handleIntelligentQaStatus(content, content_type);
        }
        if (content_type === contentType.ai_evaluation_item) {
            this.handleAiEvaluationItem(content);
        }
        if (content_type === contentType.ai_evaluation_result) {
            this.handleAiEvaluationResult(content);
        }
        if (content_type === contentType.card) {
            this.handleCard(content);
        }
        if (content_type === contentType.text) {
            this.answerContent += content;
            this.messageResult += content;
        }
    };
    handleChainEnd = (content, content_type) => {
        if (content_type === contentType.recommend_course) {
            this.recommend_course_result.loading = false;
        }
        if (content_type === contentType.workflow) {
            this.processing = false;
        }
        if (content_type === contentType.web_search) {
            this.handleWebSearch(content);
        }
        if (content_type === contentType.retrieval) {
            this.handleRetrieval(content);
        }
        //个性化推荐
        if (personalized_recommend_content_type_list.includes(content_type)) {
            if (!this.personal_recommend_result) {
                return false;
            }
            if (content_type === contentType.personalized_recommend_intent) {
                this.personal_recommend_result.personalized_recommend_intent_reasoning += thinkTag[1];
            }
            if (content_type === contentType.personalized_recommend_re_intent) {
                this.personal_recommend_result.personalized_recommend_re_intent_reasoning += thinkTag[1];
            }
            this.personal_recommend_result.loading = false;
        }
    };
    //标注和错误处理
    specialHandlers = {
        // 标注
        annotation: ({ content }) => {
            this.handleAnnotation(content);
        },
        // 错误
        error: ({ content }) => {
            this.handleError(content);
        },
        exception: ({ content }) => {
            this.handleError(content);
        },
        sensitive: ({ content }) => {
            this.handleError(content);
        }
    };

    //事件处理
    eventHandlers = {
        //链路开始
        on_chain_start: ({ content, content_type }) => {
            this.handleChainStart(content, content_type);
        },
        on_chain_stream: ({ content, content_type, message_type }) => {
            this.handleChainStream(content, content_type, message_type);
        },
        //链路结束
        on_chain_end: ({ content, content_type }) => {
            this.handleChainEnd(content, content_type);
        },
        //大模型开始
        on_chat_model_start: ({ content, content_type }) => {
            if (content_type === contentType.recommend_course) {
                if (!this.recommend_course_result) {
                    this.recommend_course_result = {};
                }
                this.recommend_course_result.loading = true;
            }
        },
        //大模型进行---流式输出会在on_chat_model_stream中处理
        on_chat_model_stream: ({ content, content_type, message_type, finish_reason }) => {
            content = content === undefined ? '' : content;

            // 检查是否完成
            if (finish_reason === 'stop') {
                this.isDone = true;
                this.processing = false;

                // 如果是最后一个消息块，并且这个消息已经在handleFlowMsg方法中被处理过，则跳过内容处理
                // 通过检查messageResult是否已经包含此内容来判断
                if (content && this.messageResult && this.messageResult.endsWith(content)) {
                    return;
                }
            }

            //根据后端实际返回来确定是否开启了深度思考
            //思考过程中deep_think为true，回答过程中为false
            if (content_type === contentType.deep_think) {
                //开启了深度思考，还未开始思考，拼接think开始标签
                if (!this.isThinking) {
                    this.messageResult += thinkTag[0];
                    this.isThinking = true;
                }
                this.thinkContent += content;
                this.messageResult += content;
            } else {
                //如果是思考结束了 需要think添加闭合标签
                if (this.isThinking) {
                    this.isThinking = false;
                    this.messageResult += thinkTag[1];
                }
                //多模态学习结果流（JSON片段）
                if (content_type === contentType.multimodal_learning) {
                    this.multimodalBuffer += content;
                    try {
                        const json = parse(this.multimodalBuffer, Allow.ALL);
                        this.multimodal_learning_result = json;
                        this.hasContent = true;
                    } catch (e) {
                        // 未能完整解析，保持缓冲区等待后续片段
                        return;
                    }
                }
                //回答内容是文本的时候--三方技能没有messageType
                if ((content_type === 'text' && (message_type === 'answer' || !message_type)) || content_type === contentType.markdown) {
                    this.answerContent += content;
                    // let nextContent = this.answerContent + content;
                    //如果答案标签未拼接，先拼接答案开始标签
                    if (!this.answerOpened) {
                        // this.messageResult += answerTag[0]isTextType;
                        this.answerOpened = true;
                    }
                    if (content) {
                        // processCompleteTags 会把普通文本与完整标签安全地追加到 this.messageResult
                        this.processCompleteTags(content, ['citation', 'glink']);
                    }
                }
                if (content_type === contentType.recommend_course) {
                    this.handleCourseRecommend(content);
                }
                //个性化推荐
                if (personalized_recommend_content_type_list.includes(content_type)) {
                    this.handlePersonalizedRecommend(content, content_type);
                }
                // if (content_type === 'text' && content) {
                //     // 检查是否已经包含此内容，避免重复
                //     if (!this.messageResult.endsWith(content)) {
                //         // this.messageResult += content;
                //         this.processCompleteTags(content);
                //     }
                // }
            }
        },
        //大模型结束
        on_chat_model_end: ({ content, content_type }) => {
            this.isDone = true;

            // 如果思考还未闭合，添加闭合标签
            if (this.isThinking) {
                this.isThinking = false;
                this.messageResult += thinkTag[1];
            }

            // 添加任何其他结束处理...
            if (content_type === contentType.recommend_course) {
                this.recommend_course_result.loading = false;
            }
        }
    };

    // 处理中断事件
    handleInterrupt(data) {
        this.isDone = true;
        this.processing = false;
        this.hasOptions = true;

        // 添加按钮选项，但不再根据editPlanMode决定是否添加按钮
        // 而是设置禁用状态，由ResearchPlanCard组件处理显示方式
        this.options = [
            {
                text: '修改计划',
                value: 'edit_plan',
                callback: () => {
                    // 当点击修改计划按钮时，设置interrupt_feedback为"edit_plan"
                    return { interrupt_feedback: 'edit_plan' };
                }
            },
            { text: '开始研究', value: 'accepted', primary: true }
        ];

        // 如果有内容，添加到消息结果中
        if (data.content) {
            this.messageResult = data.content;
        }

        return true;
    }

    //处理数据
    handleFlowMsg(data, initData) {
        // 如果直接传入了完整的 multimodal_learning_result，则优先设置并返回

        if (data && data.multimodal_learning_result) {
            this.multimodal_learning_result = data.multimodal_learning_result;
            this.hasContent = true;
        }
        if (initData) {
            if (initData?.ai_evaluation) {
                this.ai_evaluation = initData.ai_evaluation;
            }
            if (initData?.intelligent_qa_result) {
                this.intelligent_qa_result = initData.intelligent_qa_result;
            }
            if (initData?.personal_recommend_result) {
                this.personal_recommend_result = initData.personal_recommend_result;
            }
        }
        let { event, type, agent, content_type, content, message_type, finish_reason, done } = data;
        const eventName = event || type;

        // 记录 planner 的详细内容
        if (agent === 'planner' && content) {
            this.lastPlannerContent = content;
        }
        // 检查是否完成
        if (finish_reason === 'stop' || done === true) {
            this.isDone = true;
            this.processing = false;
        }

        // 优先处理中断事件
        if (eventName === 'interrupt') {
            return this.handleInterrupt(data);
        }

        // 如果是纯文本消息块，直接添加到结果中
        if (eventName === 'message_chunk' && content && !content_type) {
            // 避免重复添加相同的内容
            let contentAdded = false;

            if (!this.messageResult) {
                this.messageResult = content;
                contentAdded = true;
            } else if (!this.messageResult.endsWith(content)) {
                this.messageResult += content;
                contentAdded = true;
            }

            // 如果消息块同时包含finish_reason: "stop"，跳过后续事件处理器调用
            // 如果内容已经被添加，也不需要通过事件处理器再次处理
            if (finish_reason === 'stop' || contentAdded) {
                return this.messageResult;
            }
        }

        //标注和错误 不管什么event类型中，只要匹配到了 就直接替换处理
        if (this.specialHandlers[content_type]) {
            this.specialHandlers[content_type]({ content });
            return false;
        }

        if (this.eventHandlers[eventName]) {
            this.eventHandlers[eventName]({ content, content_type, message_type, finish_reason });
        }
    }

    reset() {
        this.thinkContent = '';
        this.answerContent = '';
        this.messageResult = '';
        this.processing = false;
        this.answerOpened = false;
        this.eventMsg = '';
        this.isThinking = false;
        this.web_result = {};
        this.retrieval_result = {};
        this.recommend_course_result = null;
        this.multimodal_learning_result = null;
        this.isDone = false;
        this.processedChunks = new Set(); // 用于记录已处理的内容块，防止重复
    }
}
